import { Component, OnInit } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import {
  faPlus,
  faPencil,
  faTrash,
  faEraser,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { OpenCategoryCoeTransferService } from "src/app/services/autopac/open-category-coe-transfer.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-open-category-coe-transfer",
  templateUrl: "./open-category-coe-transfer.component.html",
  styleUrls: ["./open-category-coe-transfer.component.css"],
})
export class OpenCategoryCoeTransferComponent implements OnInit {
  faPlus = faPlus;
  faPencil = faPencil;
  faTrash = faTrash;
  faEraser = faEraser;
  faPrint = faPrint;

  OpenCategoryCOETransfer: FormField[] = [
    {
      type: "radio",
      id: "type",
      options: [
        {
          display: "Hyundai",
          value: "1",
        },
        {
          display: "Others",
          value: "2",
        },
      ],
      value: "1",
    },
    {
      type: "radio",
      id: "empty",
    },
    {
      type: "search",
      id: "RefNo",
      label: "Buyers' Order Number",
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "search",
      id: "ContractNo",
      label: "Contract Number",
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "text",
      id: "ColourCode",
      label: "Colour",
      lock: true,
    },
    {
      type: "text",
      id: "ModelShortDesc",
      label: "Model",
      lock: true,
    },
    {
      type: "text",
      id: "VinNo",
      label: "VIN Number",
      lock: true,
    },
    {
      type: "text",
      id: "IcNo",
      label: "Buyer's NRIC",
      lock: true,
    },
    {
      type: "text",
      id: "Name",
      label: "Buyer's Name",
      lock: true,
    },
    {
      type: "text",
      id: "SalesmanCode",
      label: "Sales Consultant",
      lock: true,
    },
    {
      type: "text",
      id: "FinCompCode",
      label: "Finance Company",
      lock: true,
    },
    {
      type: "text",
      id: "SellPrice",
      label: "Selling Price",
      lock: true,
    },
  ];
  SelectCOE: FormField[] = [
    {
      type: "text",
      id: "coeBidDate",
      label: "COE Bid Date",
      lock: true,
    },
    {
      type: "text",
      id: "coeAmount",
      label: "COE Amount",
      lock: true,
    },
  ];
  SearchCOE: FormField[] = [
    {
      type: "select",
      id: "coeAmount",
      label: "COE Amount",
      options: [],
    },
    {
      type: "select",
      id: "coeBidDate",
      label: "COE Bid Date",
      options: [],
    },
  ];
  PrintOptions: FormField[] = [
    {
      type: "select",
      id: "type",
      label: "Select a print option",
      options: [
        {
          display: "By sales consultant",
          value: "salesman",
        },
        {
          display: "By model",
          value: "model",
        },
        {
          display: "By conversion",
          value: "conversion",
        },
        {
          display: "By immediate",
          value: "immediate",
        },
        {
          display: "By allocation date",
          value: "allocatedate",
        },
        {
          display: "By transfer date",
          value: "transferdate",
        },
      ],
      value: "salesman",
    },
  ];
  TableHeaders = [
    {
      type: "data",
      title: "COE AMOUNT",
      id: "CoeAmount"
    },
    {
      type: "data",
      title: "COE BID DATE",
      id: "CoeBidDate"
    },
    {
      type: "data",
      title: "NUMBER OF COES",
      id: "CoeCount"
    },
    {
      type: "edit",
      title: "ACTION",
      Hclasses: "text-center",
    },
  ];
  TableEntries: any[] = [];
  ShowSearchCOE: boolean = false;
  ShowPrint: boolean = false;
  AllowDrop: boolean = false;
  AllowUpdate: boolean = false;
  __type: string = "";

  constructor(
    private openCategoryCoeTransferService: OpenCategoryCoeTransferService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {}

  updateFields(event: any): void {
    switch (event.name) {
      case "OpenCategoryCOETransfer":
        const isHyundai =
          this.getField("type", "OpenCategoryCOETransfer").value ===
          "1";
        this.changeMode(isHyundai);
        let RefNo = this.getField(
          "RefNo",
          "OpenCategoryCOETransfer",
        ).value;
        let ContractNo = this.getField(
          "ContractNo",
          "OpenCategoryCOETransfer",
        ).value;
        this.AllowDrop = RefNo && ContractNo;
        break;
      case "SearchCOE":
        const { value: coeAmount } = this.getField(
          "coeAmount",
          "SearchCOE",
        );
        const { value: coeBidDate } = this.getField(
          "coeBidDate",
          "SearchCOE",
        );
        if (coeAmount && coeBidDate) {
          this.openCategoryCoeTransferService
            .GetCoeList(coeAmount, coeBidDate)
            .subscribe({
              next: ({ body }) => {
                this.TableEntries = body.map((item: any) => ({
                  ...item,
                  edit: "",
                }));
              },
              error: console.error,
            });
        }
        break;
    }
  }

  changeMode(isHyundai: boolean): void {
    const lockStates = {
      ColourCode: isHyundai,
      IcNo: isHyundai,
      Name: isHyundai,
      SalesmanCode: isHyundai,
    };

    Object.entries(lockStates).forEach(([field, lock]) => {
      this.getField(field, "OpenCategoryCOETransfer").lock = lock;
    });
  }

  searchNumber(event: any): void {
    const searchText = this.getField(
      event.fieldId,
      "OpenCategoryCOETransfer",
    ).value;
    this.openCategoryCoeTransferService
      .Search(event.fieldId, searchText)
      .subscribe({
        next: (response) => {
          if (response.body.Code) {
            this.notifier.notify("error", response.body.Message);
          } else {
            this.getField("type", "OpenCategoryCOETransfer").value =
              "0";
            this.changeMode(false);
            this.AllowDrop = true;
            this.__type = response.body.__type;
            Object.entries(response.body).forEach(([key, value]) => {
              this.getField(key, "OpenCategoryCOETransfer").value =
                value;
            });
            this.getField("type", "OpenCategoryCOETransfer").value =
              response.body.Option.toString();
            this.getField("coeAmount", "SelectCOE").value =
              response.body.CoeAmount;
            this.getField("coeBidDate", "SelectCOE").value =
              response.body.CoeBidDate;
            if (response.body.CoeAmount && response.body.CoeBidDate) {
              this.AllowUpdate = true;
            }
          }
        },
        error: console.error,
      });
  }

  openSearchCOE(): void {
    this.ShowSearchCOE = true;
    this.openCategoryCoeTransferService
      .GetCoeBidDateList()
      .subscribe({
        next: (response) => {
          response.body.forEach((item: string) => {
            this.getField("coeBidDate", "SearchCOE").options?.push({
              value: item,
              display: item,
            });
          });
        },
        error: console.error,
      });
    this.openCategoryCoeTransferService.GetCoeAmtList().subscribe({
      next: (response) => {
        response.body.forEach((item: string) => {
          this.getField("coeAmount", "SearchCOE").options?.push({
            value: item,
            display: item,
          });
        });
      },
      error: console.error,
    });
  }

  selectCOE(event: any): void {
    this.getField("coeAmount", "SelectCOE").value = event.CoeAmount;
    this.getField("coeBidDate", "SelectCOE").value = event.CoeBidDate;
    this.AllowUpdate = true;
  }

  printReport(): void {
    const reportType = this.getField("type", "PrintOptions").value;
    this.openCategoryCoeTransferService
      .GetCOEReport(reportType)
      .subscribe({
        next: (response) => {
          window.open(response.body.Name, "_blank");
        },
        error: console.error,
      });
  }

  clear(): void {
    this.OpenCategoryCOETransfer.forEach(
      (item) => (item.value = undefined),
    );
    this.SelectCOE.forEach((item) => (item.value = undefined));
    this.ShowSearchCOE = false;
    this.TableEntries = [];
    this.AllowUpdate = false;
    this.AllowDrop = false;
  }

  printSlip(): void {
    const searchText =
      this.getField("RefNo", "OpenCategoryCOETransfer").value ?? "";
    const coeAmount =
      this.getField("coeAmount", "SelectCOE").value ?? null;
    const coeBidDate =
      this.getField("coeBidDate", "SelectCOE").value ?? null;
    this.openCategoryCoeTransferService
      .GetCOEReservationReport(searchText, coeAmount, coeBidDate)
      .subscribe({
        next: ({ body }) => {
          if (body.Code === 0) {
            window.open(body.Name, "_blank");
          } else {
            this.notifier.notify("error", body.Message);
          }
        },
        error: console.error,
      });
  }

  dropAllocation(): void {
    this.openCategoryCoeTransferService
      .DropAllocation(this.getData())
      .subscribe({
        next: ({ body }) =>
          this.notifier.notify(
            body.Code === 0 ? "success" : "error",
            body.Message,
          ),
        error: console.error,
      });
  }

  update(): void {
    this.openCategoryCoeTransferService
      .UpdateCoe(this.getData())
      .subscribe({
        next: ({ body }) => {
          if (body.Code === 0) {
            this.notifier.notify("success", body.Message);
          } else {
            console.log(body);
          }
        },
        error: console.error,
      });
  }

  getData(): any {
    let model = {
      CaseNo: null,
      CoeAmount:
        this.getField("coeAmount", "SelectCOE").value ?? null,
      CoeBidDate:
        this.getField("coeBidDate", "SelectCOE").value ?? null,
      ColourCode:
        this.getField("ColourCode", "OpenCategoryCOETransfer")
          .value ?? null,
      ContractNo:
        this.getField("ContractNo", "OpenCategoryCOETransfer")
          .value ?? null,
      FinCompCode:
        this.getField("FinCompCode", "OpenCategoryCOETransfer")
          .value ?? null,
      IcNo:
        this.getField("IcNo", "OpenCategoryCOETransfer").value ??
        null,
      ModelShortDesc:
        this.getField("ModelShortDesc", "OpenCategoryCOETransfer")
          .value ?? null,
      Name:
        this.getField("Name", "OpenCategoryCOETransfer").value ??
        null,
      Option:
        this.getField("type", "OpenCategoryCOETransfer").value ??
        null,
      RefNo:
        this.getField("RefNo", "OpenCategoryCOETransfer").value ??
        null,
      SalesmanCode:
        this.getField("SalesmanCode", "OpenCategoryCOETransfer")
          .value ?? null,
      SellPrice:
        this.getField("SellPrice", "OpenCategoryCOETransfer").value ??
        null,
      __type: this.__type ?? null,
    };
    return model;
  }

  getField(id: string, form: string): FormField {
    const forms: { [key: string]: FormField[] } = {
      OpenCategoryCOETransfer: this.OpenCategoryCOETransfer,
      SelectCOE: this.SelectCOE,
      SearchCOE: this.SearchCOE,
      PrintOptions: this.PrintOptions,
    };
    const formData = forms[form] || [];
    return (
      formData.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
